import AUStates from './ko-KR/AU-states.json.js';
import CAStates from './ko-KR/CA-states.json.js';
import CNStates from './ko-KR/CN-states.json.js';
import CompanySize from './ko-KR/company-size.json.js';
import CompanyType from './ko-KR/company-type.json.js';
import countries from './ko-KR/countries.json.js';
import DEStates from './ko-KR/DE-states.json.js';
import HKStates from './ko-KR/HK-states.json.js';
import INStates from './ko-KR/IN-states.json.js';
import industry from './ko-KR/industry.json.js';
import interests from './ko-KR/interests.json.js';
import jobRole from './ko-KR/job-role.json.js';
import levelOfAWSUsage from './ko-KR/level-of-aws-usage.json.js';
import projectTimeline from './ko-KR/project-timeline.json.js';
import PTStates from './ko-KR/PT-states.json.js';
import USStates from './ko-KR/US-states.json.js';
import useCase from './ko-KR/use-case.json.js';
import languagePreference from './ko-KR/language-preference.json.js';
import Navatar from '../ko-KR/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
